import React from "react";
import { Box, Typography, LinearProgress } from "@material-ui/core";
import DescriptionOutlinedIcon from "@material-ui/icons/DescriptionOutlined";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import IconButton from "@material-ui/core/IconButton";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
  fileRow: {
    display: "flex",
    alignItems: "center",
    marginBottom: "12px",
    padding: "8px",
    borderRadius: "8px",
    // backgroundColor: "#F2F0EE",
    // boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
  },
  icon: {
    marginRight: "8px",
    color: "#A06DFF",
  },
  filename: {
    fontSize: 14,
    fontWeight: 500,
  },
  progressBar: {
    height: 4,
    borderRadius: 2,
    marginTop: 4,
  },
  container: {
    borderRadius: 8,
    padding: 8,
    backgroundColor: "#fff",
    marginTop: 10,
  },
}));

const Upload = ({handleDelete, filesData}) => {
    const classes = useStyles();

  return (
    <Box className={classes.container}>
      {/* Uploaded File Rows */}
      {filesData.map((file) => (
        <Box key={file.FILE_ID} className={classes.fileRow}>
          <DescriptionOutlinedIcon className={classes.icon} />
          <Box flex={1}>
            <Typography variant="body1" className={classes.filename}>
              {file.ORIGINAL_FILE_NAME}
            </Typography>
            <LinearProgress
              variant="determinate"
              value={file.progress}
              className={classes.progressBar}
            />
          </Box>
          <IconButton
            size="small"
            color="secondary"
            onClick={() => handleDelete(file.FILE_ID)}
          >
            <DeleteOutlineIcon />
          </IconButton>
        </Box>
      ))}
    </Box>
  );
};

export default Upload;
